import React, { useCallback, useRef } from "react";
import { StyleSheet, View, Pressable } from "react-native";
import CustomText from "../CustomText/CustomText";

const TabNavigator = ({
  tabData,
  activeTab,
  onTabPress,
  activeTabColor,
  isFullWidth = false,
  containerStyle = {},
  rightButtonComponent = undefined,
  useTranslationText = true,
  tabPanelIdPrefix = undefined,
}) => {
  const tabRefs = useRef({});

  const handleKeyDown = useCallback(
    (e, currentIndex) => {
      let nextIndex;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        nextIndex = (currentIndex + 1) % tabData.length;
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        nextIndex = (currentIndex - 1 + tabData.length) % tabData.length;
      } else if (e.key === "Home") {
        e.preventDefault();
        nextIndex = 0;
      } else if (e.key === "End") {
        e.preventDefault();
        nextIndex = tabData.length - 1;
      } else {
        return;
      }
      const nextTab = tabData[nextIndex];
      onTabPress(nextTab.key);
      const ref = tabRefs.current[nextTab.key];
      if (ref && typeof ref.focus === "function") {
        ref.focus();
      }
    },
    [tabData, onTabPress]
  );

  return (
    <View style={[styles.navBar, containerStyle]} accessibilityRole="tablist" role="tablist">
      {tabData.map((tab, index) => {
        const isActive = activeTab === tab.key;
        return (
          <Pressable
            ref={(el) => {
              tabRefs.current[tab.key] = el;
            }}
            nativeID={`tab-${tab.key}`}
            role="tab"
            accessibilityRole="tab"
            accessibilityLabel={tab.title}
            accessibilityState={{ selected: isActive }}
            aria-selected={isActive}
            aria-controls={tabPanelIdPrefix ? `${tabPanelIdPrefix}${tab.key}` : undefined}
            tabIndex={isActive ? 0 : -1}
            key={tab.key}
            style={[
              isActive ? [styles.activeTab, { borderBottomColor: activeTabColor }] : styles.tab,
              isFullWidth ? styles.fullWidthTab : {},
            ]}
            onPress={() => onTabPress(tab.key)}
            onKeyDown={(e) => handleKeyDown(e, index)}>
            <CustomText
              bold={isActive}
              size="s"
              style={{ color: "#646877" }}
              text={tab.title}
              useTranslationText={useTranslationText}
            />
          </Pressable>
        );
      })}
      {rightButtonComponent ? rightButtonComponent : null}
    </View>
  );
};

const styles = StyleSheet.create({
  navBar: {
    flexDirection: "row",
    justifyContent: "flex-start",
    borderBottomWidth: 1,
    borderBottomColor: "#D3D3D3",
    alignItems: "center",
  },
  tab: {
    padding: 15,
  },
  activeTab: {
    padding: 15,
    borderBottomWidth: 2,
  },
  fullWidthTab: {
    flexBasis: "33.33%",
    alignItems: "center",
  },
});

export default TabNavigator;
